// app/javascript/components/stage/StageDetailsModal.jsx
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Badge,
  Row,
  Col,
  FormGroup,
  Label
} from "reactstrap";
import Moment from "react-moment";

const statusBadge = s =>
  s === "approved"
    ? <Badge color="success">Aprobado</Badge>
    : s === "rejected"
      ? <Badge color="danger">Rechazado</Badge>
      : <Badge color="secondary">Pendiente</Badge>;

const StageDetailsModal = ({ stage, toggle }) => (
  <Modal isOpen toggle={toggle} size="lg">
    <ModalHeader className="gradient-bg text-white" toggle={toggle}>
      {stage.name} &nbsp; {statusBadge(stage.aasm_state)}
    </ModalHeader>

    <ModalBody>
      {Array.isArray(stage.requested_documents) && stage.requested_documents.length > 0 && (
        <>
          <h5 className="fw-bold text-muted mb-2">Documentos</h5>
          {stage.requested_documents.map(d => (
            <Row key={d.id} className="mb-2">
              <Col>
                <i className={`far fa-file me-2 ${d.uploaded ? "text-success" : "text-danger"}`} />
                {d.document_descriptor_name}
              </Col>
              <Col className="text-end">
                {d.uploaded && d.download_url && (
                  <>
                    <small className="text-muted me-2">
                      <i className="far fa-clock me-1" />
                      <Moment format="DD/MM/YYYY HH:mm">{d.updated_at}</Moment>
                    </small>
                    <Button
                      size="sm"
                      color="info"
                      outline
                      href={d.download_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Descargar
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          ))}
          <hr />
        </>
      )}

      {stage.metadata && Object.keys(stage.metadata).length > 0 && (
        <>
          <h5 className="fw-bold text-muted mb-2">Datos ingresados</h5>
          {Object.entries(stage.metadata).map(([k, v]) => (
            <FormGroup key={k}>
              <Label className="text-capitalize">{k.replace("_", " ")}</Label>
              <p className="mb-1">{typeof v === "boolean" ? (v ? "Sí" : "No") : v || "—"}</p>
            </FormGroup>
          ))}
          <hr />
        </>
      )}

      <h5 className="fw-bold text-muted mb-2">Observaciones</h5>
      <p>{stage.observations || "Sin observaciones."}</p>
    </ModalBody>

    <ModalFooter className="gradient-bg">
      <Button color="secondary" onClick={toggle}>
        Cerrar
      </Button>
    </ModalFooter>
  </Modal>
);

export default StageDetailsModal;
